import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import api from "../api/api";
import { toast } from "react-toastify";
import { image_base_url } from "../api/api";

function ShopDetails() {

const [shop,setShop] = useState({
  shopName:"",
  ownerName:"",
  phone:"",
  email:"",
  address:"",
  city:"",
  state:"",
  pincode:"",
  country:"",
  gstNumber:"",
  logoUrl:""
})

const [shopId,setShopId] = useState(null)
const [logoFile,setLogoFile] = useState(null)
const [preview,setPreview] = useState("")

useEffect(()=>{
 loadShop()
},[])

const loadShop = async () => {
  try{
    const res = await api.get("/settings/shop")

    if(res.data){
      setShop(res.data)
      setShopId(res.data.shopId)
      setPreview(res.data.logoUrl)
    }

  }catch(error){
    console.error("Error loading shop:",error)
  }
}

const handleLogoChange = (e)=>{
  const file = e.target.files[0]

  if(file){
    setLogoFile(file)
    setPreview(URL.createObjectURL(file))
  }
}

const handleChange=(e)=>{
 setShop({...shop,[e.target.name]:e.target.value})
}

const handleSubmit = async (e) => {
  e.preventDefault();

  try {

    const data = {
      ShopName: shop.shopName,
      OwnerName: shop.ownerName,
      Phone: shop.phone,
      Email: shop.email,
      Address: shop.address,
      City: shop.city,
      State: shop.state,
      Pincode: shop.pincode,
      Country: shop.country,
      GSTNumber: shop.gstNumber
    };

    if (shopId) {
      await api.put(`/settings/shop/${shopId}`, data);
      toast.success("Shop updated successfully");
    } 
    else {
      await api.post("/settings/shop", data);
      toast.success("Shop created successfully");
    }

    loadShop();

  } catch (error) {
    console.error("Error saving shop:", error);
  }
};

const uploadLogo = async () => {

  const formData = new FormData();
  formData.append("logoFile", logoFile);

  try {

    await api.put(`/settings/shop/logo/${shopId}`, formData);

    toast.success("Logo updated successfully");

    loadShop();

  } catch (error) {
    console.error(error);
  }
};

return (

<div className="container mt-4">

<div className="card shadow-sm">

<div className="card-header bg-dark text-white">
<h5 className="mb-0">Shop Details</h5>
</div>

<div className="card-body">

<form onSubmit={handleSubmit}>

<div className="row">

{/* LEFT SIDE - SHOP INFO */}

<div className="col-md-8">

<div className="row">

<div className="col-md-6 mb-3">
<label>Shop Name</label>
<input
name="shopName"
value={shop.shopName || ""}
onChange={handleChange}
className="form-control"
/>
</div>

<div className="col-md-6 mb-3">
<label>Owner Name</label>
<input
name="ownerName"
value={shop.ownerName || ""}
onChange={handleChange}
className="form-control"
/>
</div>

<div className="col-md-6 mb-3">
<label>Phone</label>
<input
name="phone"
value={shop.phone || ""}
onChange={handleChange}
className="form-control"
/>
</div>

<div className="col-md-6 mb-3">
<label>Email</label>
<input
name="email"
value={shop.email || ""}
onChange={handleChange}
className="form-control"
/>
</div>

<div className="col-md-12 mb-3">
<label>Address</label>
<textarea
name="address"
value={shop.address || ""}
onChange={handleChange}
className="form-control"
/>
</div>

<div className="col-md-4 mb-3">
<label>City</label>
<input
name="city"
value={shop.city || ""}
onChange={handleChange}
className="form-control"
/>
</div>

<div className="col-md-4 mb-3">
<label>State</label>
<input
name="state"
value={shop.state || ""}
onChange={handleChange}
className="form-control"
/>
</div>

<div className="col-md-4 mb-3">
<label>Pincode</label>
<input
name="pincode"
value={shop.pincode || ""}
onChange={handleChange}
className="form-control"
/>
</div>

<div className="col-md-6 mb-3">
<label>Country</label>
<input
name="country"
value={shop.country || ""}
onChange={handleChange}
className="form-control"
/>
</div>

<div className="col-md-6 mb-3">
<label>GST Number</label>
<input
name="gstNumber"
value={shop.gstNumber || ""}
onChange={handleChange}
className="form-control"
/>
</div>

</div>

</div>


{/* RIGHT SIDE - LOGO SECTION */}

<div className="col-md-4">

<div className="border p-3 text-center">

<h6 className="mb-3">Shop Logo</h6>

{preview ? (
<img
src={`${image_base_url}${preview}`}
alt="logo"
style={{width:"150px",height:"150px",objectFit:"contain"}}
/>
) : (
<div style={{height:"150px"}} className="d-flex align-items-center justify-content-center text-muted">
No Logo
</div>
)}

{shopId && (
<>

<Form.Group className="mt-3">
<Form.Control
type="file"
onChange={handleLogoChange}
/>
</Form.Group>

<Button
className="mt-2 w-100"
variant="secondary"
onClick={uploadLogo}
>
Upload Logo
</Button>

</>
)}

</div>

</div>

</div>

<div className="text-end mt-4">

<button className="btn btn-primary">
Save Settings
</button>

</div>

</form>

</div>

</div>

</div>

)

}

export default ShopDetails